(function () {
  'use strict';

  var legacyAnalyticsCookie = 'rq_whatsapp_analytics';

  function expireLegacyAnalyticsCookie() {
    var base = legacyAnalyticsCookie + '=; Max-Age=0; Path=/; SameSite=Lax';
    document.cookie = base;

    if (window.location.hostname) {
      document.cookie = base + '; Domain=' + window.location.hostname;
    }
  }

  function keepPrivacyLinksInsideCurrentPreview() {
    if (!window.Shopify || !window.Shopify.previewMode) return false;

    var links = document.querySelectorAll(
      '#shopify-pc__banner a[href*="/policies/privacy-policy"], #shopify-pc__prefs a[href*="/policies/privacy-policy"]'
    );

    links.forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        link.href = window.location.origin + url.pathname + url.search + url.hash;
      } catch (error) {
        // Leave Shopify's original URL intact if it cannot be parsed.
      }
    });

    return links.length > 0;
  }

  function localizePrivacyControls() {
    document.querySelectorAll('#shopify-pc__prefs__header-close').forEach(function (button) {
      if (!button.getAttribute('aria-label') || button.getAttribute('aria-label') === 'Close dialog') {
        button.setAttribute('aria-label', 'Cerrar preferencias');
      }
      button.setAttribute('title', 'Cerrar preferencias');
    });
  }

  function patchPrivacyPresentation() {
    localizePrivacyControls();
    return keepPrivacyLinksInsideCurrentPreview();
  }

  // Retentionly's former widget used this non-Shopify analytics cookie. The
  // widget is disabled in the theme and this removes any legacy value.
  expireLegacyAnalyticsCookie();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchPrivacyPresentation);
  } else {
    patchPrivacyPresentation();
  }

  var attempts = 0;
  var linkTimer = window.setInterval(function () {
    attempts += 1;
    if (patchPrivacyPresentation() || attempts >= 20) {
      window.clearInterval(linkTimer);
    }
  }, 250);

  document.addEventListener('click', function () {
    window.setTimeout(patchPrivacyPresentation, 0);
    window.setTimeout(patchPrivacyPresentation, 250);
  }, true);

  document.addEventListener('visitorConsentCollected', function (event) {
    if (!event.detail || event.detail.analyticsAllowed !== true) {
      expireLegacyAnalyticsCookie();
    }
  });
})();
